import SharedPreferences from "../../constants/SharedPreferences";
import {
  getErrorMessage,
  getFromStorage,
  logApiResponse,
} from "../../util/Utility";
import {
  getAuthRestclient,
  getSetTwoFARestClient,
} from "../RestUtility";
export const getMFALastUpdateTime = async (sessionId) => {
  // create a rest client
  const authRestClient = await getAuthRestclient(sessionId);
  try {
    // call the getMFALastUpdateTime API
    const userId = await getFromStorage(sessionId, SharedPreferences.USER_ID);

    // GET, matching MemberAuthController's @GetMapping("/MFALastUpdateTime"). This was a POST,
    // which the server has no mapping for — the call always failed.
    const mfaLastUpdateTimeResponse = await authRestClient.get(
      "/MFALastUpdateTime",
      {
        params: {
          userId,
        },
      },
    );
    // console.log(mfaLastUpdateTimeResponse);
    await logApiResponse(
      "mfaLastUpdateTimeResponse",
      mfaLastUpdateTimeResponse,
    );
  } catch (error) {
    console.log(error);
    if (error.response != undefined) {
      throw getErrorMessage(sessionId, error?.response?.data ?? error);
    } else {
      throw error;
    }
  }
};

export const setIsFRRegistered = async (sessionId, frRegistered) => {
  // call the setIsFRRegistered API
  try {
    // create a rest client
    const restClient = await getSetTwoFARestClient(sessionId);
    const userId = await getFromStorage(sessionId, SharedPreferences.USER_ID);
    const setIsFRRegisteredResponse = await restClient.post(
      "/twofa/setIsFRRegistered",
      { frRegistered, userId },
    );
    // console.log(setIsFRRegisteredResponse);
    await logApiResponse(
      "setIsFRRegisteredResponse",
      setIsFRRegisteredResponse,
    );
  } catch (error) {
    console.log(error);
    if (error.response != undefined) {
      throw getErrorMessage(sessionId, error?.response?.data ?? error);
    } else {
      throw error;
    }
  }
};
